"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViacomAccountEmailService = exports.viacomAccountEmailService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var changeEmail = function (request) {
    var requestRoute = "viacomAccount/email/change";
    var payload = {
        newEmail: request.newEmail,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: requestRoute,
    });
};
exports.viacomAccountEmailService = {
    changeEmail: changeEmail,
};
var ViacomAccountEmailService = /** @class */ (function () {
    function ViacomAccountEmailService() {
        return exports.viacomAccountEmailService;
    }
    return ViacomAccountEmailService;
}());
exports.ViacomAccountEmailService = ViacomAccountEmailService;
